<script lang="ts">
    import AutomaticTranslationPresenter from "./AutomaticTranslationPresenter.svelte";
    import { automaticTranslationProviderForCurrentDictionary, type AutomaticTranslationResult } from "./AutomaticTranslation.service";
    import { GoogleAutomaticTranslationProvider } from "./GoogleAutomaticTranslationProvider";

    export let phrase: string;
    export let containerElement: HTMLElement;
    export let onTranslationLoaded: (result: AutomaticTranslationResult) => void = undefined

    function loadTranslation() {
        return automaticTranslationProviderForCurrentDictionary(
            GoogleAutomaticTranslationProvider,
            phrase
        );
    }

</script>

{#key phrase}
    <AutomaticTranslationPresenter
        loadTranslation={loadTranslation()}
        {containerElement}
        {onTranslationLoaded}
    />
{/key}
